module.exports = __webpack_public_path__ + "microsoft_logo.bf10389b6cbd3abc4e7589e416b1ab2f.png";